document.addEventListener("DOMContentLoaded", function(event) { 
  const setFooterDropdowns = () => {
    const footerBlocks = document.querySelectorAll('.js-footer-block');
      
    footerBlocks.forEach((footerEl) => {
      footerEl.addEventListener('click', () => {
        if (window.innerWidth < 750) {
          footerEl.classList.toggle('open');
        }
      })
    })
  }

  setFooterDropdowns() 
});
